<script setup lang="ts">
/**
 * Habillage commun d'un champ : libellé, aide, erreur. Tous les champs de Centime l'utilisent,
 * pour des marges et une typographie identiques.
 */
import Icon from './Icon.vue'

defineProps<{
  id: string
  label: string
  hint?: string | undefined
  error?: string | undefined
}>()
</script>

<template>
  <div class="flex flex-col gap-2">
    <label :for="id" class="text-label text-ink">{{ label }}</label>
    <slot :described-by="error ? `${id}-error` : hint ? `${id}-hint` : undefined" />
    <p
      v-if="error"
      :id="`${id}-error`"
      class="flex items-start gap-1.5 text-caption text-danger"
      role="alert"
    >
      <Icon name="alert" :size="16" />
      <span>{{ error }}</span>
    </p>
    <p v-else-if="hint" :id="`${id}-hint`" class="text-caption text-ink-muted">{{ hint }}</p>
  </div>
</template>
